import { Typography, styled } from '@mui/material';

interface PageHeadingProps {
  children: React.ReactNode;
  className?: string;
  variant?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
}

const StyledPageHeading = styled(Typography)(({ }) => ({
  fontSize: '20px',
  fontWeight: 600,
  color: '#DCB22A',
  position: 'relative',
  marginBottom: '10px',
  fontFamily:'Avantt, sans-serif',
  lineHeight: '20px',
}));

const PageHeadingTypography: React.FC<PageHeadingProps> = ({ 
  children, 
  className, 
  variant = 'h4' 
}) => {
  return (
    <StyledPageHeading variant={variant} className={className}>
      {children}
    </StyledPageHeading>
  );
};

export default PageHeadingTypography;